// extracted by mini-css-extract-plugin
export var filterIncDec = "_bc-0";
export var leftBorder = "_bc-1";
export var rightBorder = "_bc-2";
export var stringInput = "_bc-3";